<template>
  <!--发单-->
  <div class="create_pjt">
    <div class="content">
      <!--选择类型-->
      <div class="pjt_type">
        <p>项目类型</p>
        <div class="picker" @click="typeShow">
          <span ref="types" class="vals" >{{selectProject.projectTypeName}} {{selectProject.projectType2Name}}</span>
          <span class="triangle"></span>
        </div>
      </div>
      <mt-popup v-model="TypePopup" position="bottom" class="popup" :closeOnClickModal=false>
        <div class="picker-toolbar">
          <span class="cancel" @click="typeHiden">取消</span>
          <span class="confirm" @click="confirmtype">确定</span>
        </div>
        <mt-picker :slots="typeSlots" @change="ontypeChange" :visible-item-count="3" class="typepicker"></mt-picker>
        <mt-picker :slots="typeSlotsone" @change="ontypeoneChange" :visible-item-count="3" class="typepickerone"></mt-picker>
      </mt-popup>
      <!--选择技能-->
      <div class="need_label">
        <div class="labels" ref="skillWrap">
          <span v-for="(skillArr,index) in skillArr" :key="index">{{skillArr}}</span>
        </div>
        <mt-button type="primary" id="select_skill" @click="labelShow">选择项目所需技能</mt-button>
      </div>
      <mt-popup v-model="labelPopup" position="right" class="showLabels">
        <div class="label_wrap">
          <div class="label_title">
            <a href="javascript:void(0)" class="label_cancel" @click="labelHiden">取消</a>
            <span>选择技能标签</span>
            <a href="javascript:void(0)" class="label_save" @click="labelSave">完成</a>
          </div>
          <ul class="label_val">
            <li v-for="{value,key} in skills" :key="key" :value='key' ref="skillsName"  @click="toggle()" >
              <span>{{value}}</span><icon name="check"></icon>
            </li>
          </ul>
          <div class="label_add" @click="labelSave">确认添加</div>
        </div>
      </mt-popup>
      <!--项目标题-->
      <div class="pjt_title">
        <p>项目标题</p>
        <input type="text" v-model="title" placeholder="一句话概括你要做什么? 比如:机械设计图纸" maxlength="20" >
      </div>
      <!--项目描述-->
      <div class="pjt_describe">
        <p>项目描述</p>
        <mt-button type="primary" @click.native="describeShow">项目描述怎么写?<icon class="info-circle" name="info-circle"></icon></mt-button>
        <textarea rows="5" v-model="describeVal" class="describe_val" placeholder="详细描述你的项目需求以及对人员的期望，让专家更全面的了解你想要什么。一、项目描述：二、主要功能点：三、可参考产品：四、人员要求"></textarea>
      </div>
      <mt-popup v-model="describe" position="right" class="describe_wrap">
        <mt-header title="项目描述">
          <mt-button icon="back" slot="left" @click="describeHiden">返回</mt-button>
        </mt-header>
        <div  ref='contract' class="contract"></div>
      </mt-popup>
      <!--添加图片-->
      <div class="add_img">
          <div class="imgs" v-for="(imgurl, index) in imgurl" :key="index">
            <icon name='times-circle' @click.native='deletePhoto(imgurl.resId)'></icon>
            <img :src="imgurl.fullPath">
          </div>
        <div class="add_btn" @click="addSave">
          <icon name="camera"></icon>
          <p>添加图片</p>
        </div>
        <input id="upDataPart" type="file" multiple accept="image/*" value="上传" ref="upDataPart" @change="onFormChange($event)" enctype="multipart/form-data"/>
      </div>
      <!--项目预算-->
      <div class="money">
        <p>项目预算</p>
        <strong>您的预算是?</strong>
        <div id="moneyPicker" @click="moneyShow">
          <strong>￥</strong>
          <span ref="moneyVal">{{selectProject.prePriceName}}</span>
          <div class="triangle"></div>
        </div>
      </div>
      <mt-popup v-model="moneyPopup" position="bottom" class="popup" :closeOnClickModal=false>
        <div class="picker-toolbar">
          <span class="cancel" @click="moneyHiden">取消</span>
          <span class="confirm" @click="confirmMoney">确定</span>
        </div>
        <mt-picker class="moneyPickerWrap" :slots="moneySlots" @change="onMoneyChange" :visible-item-count="3"></mt-picker>
      </mt-popup>
      <!--项目周期-->
      <div class="time">
        <p>项目周期</p>
        <strong>预计交付在?</strong>
        <div id="timePicker" @click="timeShow"><span ref="timeVal">{{selectProject.periodName}}</span><div class="triangle"></div></div>
      </div>
      <mt-popup v-model="timePopup" position="bottom" class="popup" :closeOnClickModal=false>
        <div class="picker-toolbar">
          <span class="cancel" @click="timeHiden">取消</span>
          <span class="confirm" @click="confirmtime">确定</span>
        </div>
        <mt-picker class="pickerWrap" :slots="timeSlots" @change="onTimeChange" :visible-item-count="3"></mt-picker>
      </mt-popup>
      <!--所属行业-->
      <div class="industry">
        <p>所属行业</p>
        <div class="industryPicker"   @click='industryShow' ><span ref="industryVal" >{{selectProject.industryName}}</span><div class="triangle"></div></div>
      </div>
      <mt-popup v-model="industryPopup" position="bottom" class="popup" :closeOnClickModal=false>
        <div class="picker-toolbar">
          <span class="cancel" @click="industryHiden">取消</span>
          <span class="confirm" @click="confirmIndustry">确定</span>
        </div>
        <mt-picker class="pickerWrap" :slots="industrySlots" @change="onIndustryChange" :visible-item-count="3"></mt-picker>
      </mt-popup>
      <!--所在城市-->
      <div class="city">
        <p>所在城市</p>
        <div class="cityPicker" @click='cityShow'><span ref='cityVal'>{{selectProject.cityName}}</span><div class="triangle"></div></div>
      </div>
      <mt-popup v-model="cityPopup" position="bottom" class="popup" :closeOnClickModal=false>
        <div class="picker-toolbar">
          <span class="cancel" @click="cityHiden">取消</span>
          <span class="confirm" @click="confirmCity">确定</span>
        </div>
        <mt-picker class="pickerWrap" :slots="citySlots" @change="onCityChange" :visible-item-count="3"></mt-picker>
      </mt-popup>
      <!--企业名称-->
      <div class="company_name">
        <p>企业名称</p>
        <!-- <input type="text" v-model="companyName"  v-validate="'required|min:0|max:20'" placeholder="如果是公司发布项目，请输入公司名称(选填)" :value="selectProject.companyName"/> -->
        <input type="text" v-model="companyName"  v-validate="'required|min:0|max:20'" placeholder="如果是公司发布项目，请输入公司名称(选填)"/>
      </div>
      <!--让谁完成-->
      <div class="who">
        <p>倾向让谁完成项目</p>
        <span v-for="(who,index) in who" :key="index" @click="selected(who)"  :class='{select:actWho==who.type}'>{{who.key}}</span>
      </div>
      <!--发票-->
      <div class="fapiao">
        <p>是否要发票</p>
        <span v-for="(invoice,index) in invoice" :key="index" @click="selectInvoice(invoice)" :class='{select:actInvoice==invoice.type}'>{{invoice.key}}</span>
      </div>
    </div>
    <div class="release_btn" @click="sumbitProject">发布新任务</div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
export default {
  name: 'message',
  data () {
    return {
      typeSlots: [
        {
          flex: 1,
          values: [],
          className: 'slot1',
          textAlign: 'center',
          defaultIndex: 0
        }, {
          divider: true,
          content: '-',
          className: 'slot2'
        }
      ],
      typeSlotsone: [
        {
          flex: 1,
          values: [],
          className: 'slot3',
          textAlign: 'center',
          defaultIndex: 0
        }
      ],
      areaList: [],
      accountId: '',
      imgurl: [],
      imgIdArr: [],
      photoList: [],
      imgList: [],
      selectProject: '',
      title: '',
      companyName: '',
      projectCodeList: '',
      projectTwoCodeList: '',
      cityCodeList: '',
      prePriceCodeList: '',
      periodCodeList: '',
      IndustryCodeList: '',
      cityId: '',
      cityName: '',
      prePriceId: '',
      prePriceName: '',
      periodId: '',
      periodName: '',
      IndustryId: '',
      projectType: '',
      projectTypeName: '',
      projectTypeId: '',
      projectType2: '',
      projectType2Name: '',
      projectType2Id: '',
      type: '',
      TypePopup: false,
      labelPopup: false,
      SelectType: '',
      skills: [],
      skillArr: [],
      skillArrTemp: [],
      idArr: [],
      idArrTemp: [],
      describe: false,
      describeVal: '',
      moneyList: [],
      moneySlots: [
        {
          flex: 1,
          values: [],
          textAlign: 'center',
          defaultIndex: 0
        }
      ],
      moneyPopup: false,
      SelectMoney: '',
      timeList: [],
      timeSlots: [
        {
          flex: 1,
          values: [],
          textAlign: 'center',
          defaultIndex: 0
        }
      ],
      timePopup: false,
      SelectTime: '',
      industryList: [],
      industrySlots: [
        {
          flex: 1,
          values: [],
          textAlign: 'center',
          defaultIndex: 0
        }
      ],
      industryPopup: false,
      SelectIndustry: '',
      cityList: [],
      citySlots: [
        {
          flex: 1,
          values: [],
          textAlign: 'center',
          defaultIndex: 0
        }
      ],
      cityPopup: false,
      SelectCity: '',
      who: [{key: '没有倾向', type: '0'}, {key: '个人', type: '1'}, {key: '工作室/团队', type: '2'}],
      actWho: '0',
      invoice: [{key: '不需要', type: '0'}, {key: '需要乙方（服务方）提供发票', type: '1'}],
      actInvoice: '0',
      onevalue: ''
    }
  },
  mounted () {
    this.loadProjectBata()
    this.vueSelectproject()
    this.contract()
    this.STATE.state.bottomindex='btnThree'
  },
  methods: {
     // 云智图项目描述
    contract: function () {
      let _this = this
      this.axios({
        method: 'post',
        url: 'http://blog.yunzhitu.com/presentation-sample/feed/json ',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (res) {
        _this.$refs.contract.innerHTML = res.data.items[0].content_html
      })
    },
    loadProjectBata: function () {
      let _this = this
      this.axios.get('url/work/project/vueGetProjectData')
      .then(function (res) {
        _this.moneyList = res.data.prePrice
        _this.timeList = res.data.period
        _this.industryList = res.data.industry
        _this.cityList = res.data.city
        _this.projectCodeList = res.data.projectCode
        _this.projectTwoCodeList = res.data.projectTwoCode
        _this.cityCodeList = res.data.cityCode
        _this.prePriceCodeList = res.data.prePriceCode
        _this.periodCodeList = res.data.periodCode
        _this.IndustryCodeList = res.data.industryCode
        _this.areaList = res.data.projectTypes
        _this.type = _this.areaList[0]
        _this.typeSlots[0].values = Object.keys(_this.type)
        _this.typeSlotsone[0].values = Object.values(_this.type)[0]
        _this.moneySlots[0].values = Object.values(_this.moneyList[0])[0]
        _this.timeSlots[0].values = Object.values(_this.timeList[0])[0]
        _this.industrySlots[0].values = Object.values(_this.industryList[0])[0]
        _this.citySlots[0].values = Object.values(_this.cityList[0])[0]
        // console.log(_this.typeSlots[0].values)
        // console.log(_this.typeSlots[2].values)
      })
    },
    sumbitProject: function () {
      let _this = this
      var skillsId = ''
      if (_this.idArr.length > 0) {
        for (var i = 0; i < _this.idArr.length; i++) {
          if ((i + 1) < _this.idArr.length) {
            skillsId += _this.idArr[i] + '@'
          } else {
            skillsId += _this.idArr[i]
          }
        }
      }
      var imgId = ''
      if (_this.imgIdArr.length > 0) {
        for (var j = 0; j < _this.imgIdArr.length; j++) {
          if ((j + 1) < _this.imgIdArr.length) {
            imgId += _this.imgIdArr[j] + '@'
          } else {
            imgId += _this.imgIdArr[j]
          }
        }
      }
      if (_this.$refs.types.innerText === '') {
        Toast({
          message: '请选择项目类型',
          position: 'middle',
          className: 'indexClass',
          duration: 1000
        })
        return false
      }
      if (skillsId === '') {
        Toast({
          message: '请选择技能',
          position: 'middle',
          className: 'indexClass',
          duration: 1000
        })
        return false
      }
      if (_this.title === null || _this.title ==='' || _this.title ===undefined) {
        Toast({
          message: '项目标题不能为空',
          position: 'middle',
          className: 'indexClass',
          duration: 1000
        })
        return false
      }
      if (_this.describeVal === ''||_this.describeVal === null||_this.describeVal === undefined) {
        Toast({
          message: '项目描述不为空',
          position: 'middle',
          className: 'indexClass',
          duration: 1000
        })
        return false
      }
      if (_this.describeVal.length < 50 || _this.describeVal.length > 1000) {
        Toast({
          message: '项目描述需在50-1000个字以内',
          position: 'middle',
          className: 'indexClass',
          duration: 1000
        })
        return false
      }
      // 图片数量
      var pho = document.getElementsByClassName('imgs')
      if (pho.length > 5) {
        Toast({
          message: '只能上传五张图片',
          position: 'middle',
          className: 'indexClass',
          duration: 1000
        })
        return false
      }
      if (_this.$refs.moneyVal.innerText === '') {
        Toast({
          message: '请选择您的预算',
          position: 'middle',
          className: 'indexClass',
          duration: 1000
        })
        return false
      }
      if (_this.$refs.timeVal.innerText === '') {
        Toast({
          message: '请选择项目周期',
          position: 'middle',
          className: 'indexClass',
          duration: 1000
        })
        return false
      }
      if (_this.$refs.industryVal.innerText === '') {
        Toast({
          message: '请选择所属行业',
          position: 'middle',
          className: 'indexClass',
          duration: 1000
        })
        return false
      }
      if (_this.$refs.cityVal.innerText === '') {
        Toast({
          message: '请选择所在城市',
          position: 'middle',
          className: 'indexClass',
          duration: 1000
        })
        return false
      }
      if (_this.companyName === '') {
        Toast({
          message: '企业名称不能为空',
          position: 'middle',
          className: 'indexClass',
          duration: 1000
        })
        return false
      }
      _this.accountId = sessionStorage.getItem('loginId')
      if (_this.accountId === 0) {
        _this.$router.push({name: 'login', params: { fromPath: '/project/creatpjt' }})
      }
      this.axios({
        method: 'post',
        url: 'url/work/project/sumbitproject?accountId=' + _this.accountId + '',
        params: {
          projectType: _this.projectTypeId,
          projectType2: _this.projectType2Id,
          skills: skillsId,
          photo: imgId,
          title: _this.title,
          description: _this.describeVal,
          prePrice: _this.prePriceId,
          period: _this.periodId,
          companyName: _this.companyName,
          industry: _this.IndustryId,
          city: _this.cityId,
          enterType: _this.actWho,
          isInvoice: _this.actInvoice
        }
      }).then(function (response) {
        let msg = ''
        if (response.data.success) {
          _this.$router.push({path: '/project/createProject/createSuccess'})
        } else if (response.data.msg !== null) {
          msg = response.data.msg
          Toast({
            message: msg,
            position: 'middle',
            duration: 1000
          })
        } else {
          _this.$router.push({name: 'login', params: { fromPath: '/project/creatpjt' }})
        }
      }).catch(function (response) {
        Toast({
          message: '网络异常',
          position: 'middle',
          duration: 1000
        })
      })
    },
    deletePhoto: function (photoId) {
      var imgurlnew = []
      for (var i = 0; i < this.imgurl.length; i++) {
        if (this.imgurl[i].resId !== photoId) {
          imgurlnew.push(this.imgurl[i])
        }
      }
      this.imgurl = imgurlnew
      // console.log(this.imgurl)
      if (photoId !== '') {
        this.axios({
          method: 'POST',
          url: '/url/common/deleteImg',
          timeout: 100000,
          params: {
            id: photoId
          }
        }).then(function (res) {
          console.log('删除资源图片成功')
        }).catch(function (res) {
          console.log('删除资源图片失败')
        })
      }
    },
    vueSelectproject: function () {
      let _this = this
      this.axios.get('url/work/project/vueSelectproject')
      .then(function (response) {
        _this.selectProject = response.data
        _this.title = _this.selectProject.title
        _this.describeVal = _this.selectProject.description
        _this.companyName = _this.selectProject.companyName
        if (response.data.enterType !== null) {
          _this.actWho = response.data.enterType
        }
        // _this.actWho = response.data.enterType
        if (response.data.isInvoice !== null) {
          _this.actInvoice = response.data.isInvoice
        }
        _this.projectTypeId = response.data.projectType
        _this.projectTypeName = response.data.projectTypeName
        _this.projectType2Id = response.data.projectType2
        _this.projectType2Name = response.data.projectType2Name
        _this.prePriceId = response.data.prePrice
        _this.prePriceName = response.data.prePriceName
        _this.periodId = response.data.period
        _this.periodName = response.data.periodName
        _this.IndustryId = response.data.industry
        _this.IndustryName = response.data.IndustryName
        _this.cityId = response.data.city
        _this.cityName = response.data.cityName
        _this.projectPhoto(response.data.photo)
        if (response.data.skillsName !== null) {
          _this.skillArr = response.data.skillsName.split('@')
        }
        _this.skillArrTemp = _this.skillArr
        if (response.data.skills !== null) {
          _this.idArr = response.data.skills.split('@')
        }
        _this.idArrTemp = _this.idArr
      })
    },
    // 获取照片
    projectPhoto: function (photo) {
      let _this = this
      this.axios.get('url/common/getphoto?resid=' + photo + '')
      .then(function (res) {
        for (var i = 0; i < res.data.data.length; i++) {
          var photoList = {}
          photoList.resId = res.data.data[i].id
          photoList.fullPath = res.data.data[i].fullPath
          var photoIdList = {}
          photoIdList = res.data.data[i].id
          _this.imgIdArr.push(photoIdList)
          _this.imgurl.push(photoList)
        }
      })
    },
    onFormChange: function (e) {
      let _this = this
      let file = e.target.files[0]
      let param = new FormData()
      param.append('file', file)
      param.append('imgSize', '10') // 额外参数设置
      this.axios({
        method: 'post',
        url: '/url/common/uploadImg',
        timeout: 100000,
        data: param
      }).then(function (response) {
        // console.log(response.data.data)
        _this.imgIdArr.push(response.data.data.id)
        var img = {}
        img.resId = response.data.data.id
        img.fullPath = response.data.data.fullPath
        _this.imgurl.push(img)
      }).catch(function (response) {
        console.log('失败')
      })
    },
    typeShow: function () {
      this.TypePopup = true
    },
    typeHiden: function () {
      this.TypePopup = false
    },
    confirmtype: function (picker, values) {
      this.$refs.types.innerHTML = this.SelectType
      if (this.projectTypeName !== this.SelectType.split(' ')[0]) {
        this.projectTypeId = this.projectCodeList[0][this.SelectType.split(' ')[0]] + ''
      }
      if (this.projectType2Name !== this.SelectType.split(' ')[1]) {
        this.projectType2Id = this.projectTwoCodeList[0][this.SelectType.split(' ')[1]] + ''
      }
      this.TypePopup = false
    },
    ontypeChange: function (picker, values) {
      console.log(values)
      this.skills = ''
      if (this.skillArrTemp.length > 0) {
        this.skillArr = this.skillArrTemp
        this.idArr = this.idArrTemp
        this.skillArrTemp = []
        this.idArrTemp = []
      } else {
        this.skillArr = []
        this.idArr = []
      }
      this.typeSlotsone[0].values = Object.values(this.type)[this.typeSlots[0].values.indexOf(values[0])]
      this.onevalue = values[0]
      this.projectType = values[0]
    },
    ontypeoneChange: function (picker, values) {
      this.SelectType = this.onevalue + ' ' + values[0]
      this.projectType2 = values[0]
    },
    labelShow: function () {
      let _this = this
      this.axios({
        method: 'get',
        url: 'url/work/project/vueGetSkill',
        params: {
          Id: _this.projectType2Id
        }
      }).then(function (res) {
        _this.skills = res.data.skill
      })
      this.labelPopup = true
    },
    labelHiden: function () {
      this.labelPopup = false
    },
    labelSave: function () {
      if (this.skillArr.length < 1) {
        alert('选择一个技能')
      } else {
        this.labelPopup = false
      }
    },
    toggle: function () {
      if (this.idArr.indexOf(event.currentTarget.getAttribute('value')) !== -1) {
        var i = this.idArr.indexOf(event.currentTarget.getAttribute('value'))
        this.idArr.splice(i, 1)
        this.skillArr.splice(i, 1)
        event.currentTarget.className = ''
        return
      } else {
        this.idArr.push(event.currentTarget.getAttribute('value'))
        this.skillArr.push(event.currentTarget.firstChild.innerHTML)
        event.currentTarget.className = 'select'
        return
      }
    },
    bodyScroll: function (event) {
      event.preventDefault()
    },
    describeShow: function () {
      this.describe = true
      document.body.addEventListener('touchmove', this.bodyScroll)
    },
    describeHiden: function () {
      this.describe = false
      document.body.removeEventListener('touchmove', this.bodyScroll)
    },
    addSave: function () {
      this.$refs.upDataPart.click()
    },
    moneyShow: function () {
      this.moneyPopup = true
    },
    moneyHiden: function () {
      this.moneyPopup = false
    },
    confirmMoney: function (picker, values) {
      this.$refs.moneyVal.innerHTML = this.SelectMoney
      if (this.prePriceName === null || this.prePriceName !== this.SelectMoney) {
        this.prePriceId = this.prePriceCodeList[0][this.SelectMoney]
      }
      this.moneyPopup = false
    },
    onMoneyChange: function (picker, values) {
      this.SelectMoney = values[0]
      // console.log(values)
    },
    timeShow: function () {
      this.timePopup = true
    },
    timeHiden: function () {
      this.timePopup = false
    },
    confirmtime: function (picker, values) {
      this.$refs.timeVal.innerHTML = this.SelectTime
      if (this.periodName === null || this.periodName !== this.SelectTime) {
        this.periodId = this.periodCodeList[0][this.SelectTime]
      }
      this.timePopup = false
    },
    onTimeChange: function (picker, values) {
      this.SelectTime = values[0]
    },
    industryShow: function () {
      this.industryPopup = true
    },
    industryHiden: function () {
      this.industryPopup = false
    },
    confirmIndustry: function (picker, values) {
      this.$refs.industryVal.innerHTML = this.SelectIndustry
      if (this.industryName === null || this.industryName !== this.SelectIndustry) {
        this.IndustryId = this.IndustryCodeList[0][this.SelectIndustry]
      }
      this.industryPopup = false
    },
    onIndustryChange: function (picker, values) {
      this.SelectIndustry = values[0]
    },
    cityShow: function () {
      this.cityPopup = true
    },
    cityHiden: function () {
      this.cityPopup = false
    },
    confirmCity: function (picker, values) {
      this.$refs.cityVal.innerHTML = this.SelectCity
      if (this.cityName === null || this.cityName !== this.$refs.cityVal.innerHTML) {
        this.cityId = this.cityCodeList[0][this.SelectCity]
      }
      this.cityPopup = false
    },
    onCityChange: function (picker, values) {
      this.SelectCity = values[0]
    },
    selected: function (who) {
      this.actWho = who.type
    },
    selectInvoice: function (invoice) {
      this.actInvoice = invoice.type
    }
  }
}
</script>

<style scoped>
.content{
  padding:20px;
}
p{
  font-size:12px;
  margin-bottom:10px;
  color:#8f8f94;
}
.picker{
 padding:7px 0;
 border:none;
 border-bottom:1px solid #d6d6d6;
 font-size:14px;
 text-align:center;
 position:relative;
}
.triangle{
  width:0;
  height:0;
  border-left:8px solid transparent;
  border-right:8px solid transparent;
  border-top:8px solid #808b98;
  position:absolute;
  right:10px;
  top:13px;
}
.need_label{
  margin:20px 0;
}
.labels{
  margin-bottom:15px;
}
.labels span{
  display: inline-block;
  color: #007AFF;
 	font-size: 16px;
 	border: 1px solid #007AFF;
 	-webkit-border-radius: 3px;
 	-moz-border-radius: 3px;
 	border-radius: 3px;
 	margin: 5px;
 	padding: 0 10px;
}
#select_skill{
  font-size:14px;
  height:33px;
}
.pjt_title input{
  width:100%;
  font-size:14px;
  padding:10px 0;
  border:none;
  border-bottom:1px solid #d6d6d6;
  outline:none;
  margin-bottom:15px;
}
.pjt_describe button{
  font-size:12px;
  padding:0 10px;
  height:23px;
  line-height:23px;
  float:right;
}
.pjt_describe p{
  display:inline-block;
}
.info-circle{
  height:15px;
  vertical-align:middle;
  margin-left:5px;
}
.pjt_describe .describe_val{
  resize:none;
  width:100%!important;
  font-size:14px;
  padding:10px 15px;
  margin-bottom:15px;
  box-sizing:border-box;
  border:1px solid rgba(0,0,0,.2);
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  outline:none;
}
.img_list{
  overflow:hidden;
}
.img_list li{
 float:left;
 position:relative;
 margin:5px;
}
.img_list li img{
  max-width:66px;
  height:auto;
}
.img_list li .fa-icon{
  position:absolute;
  top:-5px;
  right:-5px;
}
.add_img{
  margin: 10px 0;
}
.add_img .imgs{
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  margin: 5px;
}
.add_img .imgs{
  width: 65px;
  height: 65px;
  border: 1px solid #ccc;
  position: relative;
}
.add_img .imgs img{
  max-width: 100%;
  max-height: 100%;
  margin-top: 50%;
  transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
}
.add_img .imgs .fa-icon{
  position: absolute;
  top: -5px;
  right: -5px;
}
.add_btn{
  width:66px;
  height:66px;
  border:1px dashed #cdcdcd;
  text-align:center;
  margin:0 0 20px 5px;
}
.add_btn svg{
  margin-top:15px;
}
.money,.time{
  overflow:hidden;
  margin-bottom:20px;
}
#moneyPicker,#timePicker{
  position:relative;
  padding:7px 0;
  border:none;
  border-bottom:1px solid #d6d6d6;
  width:60%;
  float:right;
  margin-top:-10px;
}
#moneyPicker span,#timePicker span{
  font-size:14px;
  margin-left:5px;
  display:inline-block;
  width:75%;
}
#moneyPicker .triangle{
  top:16px;
}
strong{
  font-size:14px;
}
#timePicker{
  height:22px;
}
.industryPicker,.cityPicker{
  position:relative;
  padding:7px 0;
  border:none;
  border-bottom:1px solid #d6d6d6;
  text-align:center;
}
.industryPicker span,.cityPicker span{
  font-size:14px;
  display:inline-block;
  width:85%;
}
.industry,.city,.company_name{
  margin-bottom:20px;
}
.company_name input{
  display:block;
  width:100%;
  font-size:14px;
  padding:10px 0;
  border:none;
  border-bottom:1px solid #d6d6d6;
  text-align:center;
  outline:none;
}
.who{
  margin-bottom: 20px;
}
.who span{
  font-size:14px;
  border:1px solid #dcdcdc;
  background-color:#f7f7f7;
  padding:4px 12px;
  margin:0 5px;
  border-radius:3px;
  -webkit-border-radius:3px;
  -moz-border-radius:3px;
}
.fapiao span{
  font-size:14px;
  border:1px solid #dcdcdc;
  background-color:#f7f7f7;
  padding:4px 8px;
  margin:0 5px;
  border-radius:3px;
  -webkit-border-radius:3px;
  -moz-border-radius:3px;
}
.select{
  background-color:#108ee9!important;
  color:#fff!important;
}
.release_btn{
  margin-bottom:60px;
  height:50px;
  text-align:center;
  background-color:#108ee9;
  color:#fff;
  font-size:16px;
  line-height:50px;
}
.popup{
  width:100%;
}
.picker-toolbar{
  padding: 6px;
  overflow:hidden;

}
.cancel{
  float:left;
  font-size:12px;
  padding:5px 10px;
  border:1px solid #ccc;
  border-radius:3px;
  -webkit-border-radius:3px;
  -moz-border-radius:3px;
}
.confirm{
  float:right;
  font-size:12px;
  padding:5px 10px;
  color:#fff;
  border:1px solid #007aff;
  background-color:#007aff;
  border-radius:3px;
  -webkit-border-radius:3px;
  -moz-border-radius:3px;
}
.showLabels{
  width:100%;
  height:100%;
  padding:18px;
  box-sizing: border-box;
  overflow-y: auto;
}
.label_wrap{
  width:100%;
  border:1px solid #d6d6d6;
}
.label_title{
  text-align:center;
  border-bottom:1px solid #d6d6d6;
  line-height:50px;
}
.label_title .label_cancel{
  float:left;
  margin-left:10px;
  color:#808080;
}
.label_title .label_save{
  float:right;
  margin-right:10px;
  color:#007aff;
}
.label_title a{
  font-size:14px;
  text-decoration:none;
}
.label_title span{
  font-weight:bold;
}
.label_val{
  padding:10px;
  overflow:hidden;
}
.label_val li{
  float:left;
  border:1px solid #007AFF;
  color:#007AFF;
  border-radius:3px;
  -webkit-border-radius:3px;
  -moz-border-radius:3px;
  padding:2px 10px;
  margin:5px;
}
.label_val li .fa-icon{
  width:12px;
  height:12px;
  margin-left:5px;
  color:#fff;
}
.label_add{
  width:100%;
  line-height:50px;
  color:#fff;
  background-color:#007AFF;
  text-align:center;
}
.describe_wrap{
  width:100%;
  height:100%;
}
pre{
  padding:10px;
}
#upDataPart{
  display:none;
}
.pickerWrap{
  height:100px;
}

.typepicker{
  width:50%;
  float:left;
}
.typepickerone{
  width:50%;
  float:right;
}
</style>



// WEBPACK FOOTER //
// create_pjt.vue?ce70fa96